import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from '@growdash/design-system/atoms';
import { useEffect, useState } from 'react';

interface ChangeBillingAddressDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleSubmit: (addressData: { address: string }) => void;
  isSubmitting: boolean;
  initialAddress?: string;
  initialCity?: string;
  initialState?: string;
}

export function ChangeBillingAddressDialog({
  isOpen,
  setIsOpen,
  handleSubmit,
  isSubmitting,
  initialAddress = '',
  initialCity = '',
  initialState = '',
}: ChangeBillingAddressDialogProps) {
  const [address, setAddress] = useState(initialAddress);

  useEffect(() => {
    if (isOpen) {
      setAddress(initialAddress);
    }
  }, [isOpen, initialAddress, initialCity, initialState]);

  const onSubmit = () => {
    handleSubmit({ address });
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Change Billing Address</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="address" className="text-right">
              Address
            </Label>
            <Input
              id="address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="col-span-3"
              placeholder="123 Main St"
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => setIsOpen(false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button onClick={onSubmit} disabled={isSubmitting || !address.trim()}>
            {isSubmitting ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
